// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2QACo","name":"ConsentHeader_name__1ZbO1","birthday":"ConsentHeader_birthday__1JvO3","skeleton":"ConsentHeader_skeleton__1XxJV"};